import React from 'react'
import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'
import classnames from '@helpers/misc/classnames'
import truncate from 'lodash/truncate'
import InformativeStamps from 'src/components/InformativeStamps'
export interface Props {
  product: productListInformation
}
function ProductDescriptionSection(props: Props) {
  const {product} = props
  const {name, description, isOutOfStock, availabilityAt} = product
  const disabledProduct = isOutOfStock || !availabilityAt?.available
  const informativeStampsList = product?.informativeStamps?.slice(0, 3)

  return (
    <div
      className={classnames('max-h-28 overflow-hidden text-ellipsis break-words', {
        'opacity-40': disabledProduct
      })}>
      <div className="font-semibold text-base flex flex-row items-center text-black cursor-pointer">
        {truncate(name, {length: 32})}
        <span className="ml-1">
          <InformativeStamps stamps={informativeStampsList} iconOnly={true} />
        </span>
      </div>
      <p className="text-xs text-gray-400 max-h-16">{description}</p>
    </div>
  )
}
export default ProductDescriptionSection
